import LeaderboardEmptyState from "@/components/dashboard/leaderboards/LeaderboardEmptyState";
import LeaderboardSkeleton from "@/components/dashboard/leaderboards/LeaderboardSkeleton";
import LeaderboardTable from "@/components/dashboard/leaderboards/LeaderboardTable";
import { useLeaderboards } from "@/hooks/leaderboards/useLeaderboards";
import { convertLetters } from "@/utils/letterConversion";
import { useState } from "react";

const PAGE_SIZE = 50;

const LifetimePage: React.FC = () => {
    const [lifetimeOffset, setLifetimeOffset] = useState(0);
    const [shieldOffset, setShieldOffset] = useState(0);

    const {
        topPlayersLifetime,
        topPlayersShieldValue,
        loading,
        error,
        lifetimeQuery,
        shieldQuery,
    } = useLeaderboards({
        lifetimeOffset,
        shieldOffset,
        limit: PAGE_SIZE,
    });

    const handleLoadMoreLifetime = () => {
        lifetimeQuery.fetchMore({
            variables: {
                offset: lifetimeOffset + PAGE_SIZE,
                limit: PAGE_SIZE,
            },
        });
        setLifetimeOffset((prev) => prev + PAGE_SIZE);
    };

    const handleLoadMoreShield = () => {
        shieldQuery.fetchMore({
            variables: {
                offset: shieldOffset + PAGE_SIZE,
                limit: PAGE_SIZE,
            },
        });
        setShieldOffset((prev) => prev + PAGE_SIZE);
    };

    if (loading && lifetimeOffset === 0 && shieldOffset === 0)
        return <LeaderboardSkeleton />;
    if (error)
        return (
            <LeaderboardEmptyState message="Failed to load leaderboard data." />
        );

    return (
        <div className="grid grid-cols-1 gap-6 xl:grid-cols-2">
            <div className="border-brand rounded-xl border bg-zinc-900/55 p-4 sm:p-5">
                <h2 className="font-prviking text-brand mb-4 text-center text-2xl">
                    {convertLetters("Lifetime VP")}
                </h2>
                {topPlayersLifetime.length > 0 ? (
                    <>
                        <LeaderboardTable players={topPlayersLifetime} />
                        <div className="mt-4 flex justify-center">
                            <button
                                onClick={handleLoadMoreLifetime}
                                className="font-prviking bg-brand text-brand_charcoal border-brand hover:bg-brand/80 rounded-lg border px-4 py-2 transition"
                            >
                                {convertLetters("Load More")}
                            </button>
                        </div>
                    </>
                ) : (
                    <LeaderboardEmptyState message="No lifetime data available." />
                )}
            </div>
            <div className="border-brand rounded-xl border bg-zinc-900/55 p-4 sm:p-5">
                <h2 className="font-prviking text-brand mb-4 text-center text-2xl">
                    {convertLetters("Shield Value")}
                </h2>
                {topPlayersShieldValue.length > 0 ? (
                    <>
                        <LeaderboardTable players={topPlayersShieldValue} />
                        <div className="mt-4 flex justify-center">
                            <button
                                onClick={handleLoadMoreShield}
                                className="font-prviking bg-brand text-brand_charcoal border-brand hover:bg-brand/80 rounded-lg border px-4 py-2 transition"
                            >
                                {convertLetters("Load More")}
                            </button>
                        </div>
                    </>
                ) : (
                    <LeaderboardEmptyState message="No shield value data available." />
                )}
            </div>
        </div>
    );
};

export default LifetimePage;
